import {toastStore} from '@/shared/stores/toastStore';

export const showInfoToast = (source: Element, message: string, duration?: number) => {
    toastStore.showToast({
        message,
        duration,
        severity: 'info',
    });
};

export const showSuccessToast = (source: Element, message: string, duration?: number) => {
    toastStore.showToast({
        message,
        duration,
        severity: 'success',
    });
};

export const showErrorToast = (source: Element, message: string, duration?: number) => {
    toastStore.showToast({
        message,
        duration,
        severity: 'error',
    });
};
